export default __webpack_public_path__ + "static/media/banner_demo.c5dc1ba6.jpeg";